









































































import Vue from 'vue';
import _ from 'lodash';
import CustomDialog from '../CustomDialog.vue';

export default Vue.extend({
  name: 'ThePacienteWebcamDialog',
  props: {
    value: {
      type: Boolean,
    },
  },
  components: {
    CustomDialog,
  },
  data() {
    return {
      dialog: false,
      imagem: null,
      cameras: [],
    };
  },
  computed: {
    selectedCamera() {
      return this.$refs.webcamComponent ? this.$refs.webcamComponent.getDeviceId() : null;
    },
  },
  methods: {
    tirarFoto() {
      this.imagem = this.$refs.webcamComponent.capture();
    },
    cancelarFoto() {
      this.imagem = null;
    },
    selecionarFoto() {
      this.$emit('foto-selecionada', this.imagem);
    },
    camerasLoaded(cameras) {
      this.cameras = _.map(cameras, (el, index) => ({ value: el.deviceId, text: `Camera #${index}` }));
      if (this.cameras.length > 0) {
        this.escolheCamera(this.cameras[0].deviceId);
      }
    },
    escolheCamera(deviceId) {
      this.$refs.webcamComponent.changeCamera(deviceId);
    },
  },
  watch: {
    value() {
      this.dialog = this.value;
    },
  },
});
